define([
  'react',
  'prop-types',
  'immutable',
  'underscore',
  'jsx!launcher/views/listbuilder/wysiwyg/components/Component',
], (React, PropTypes, Immutable, _, Component) => {
  const VALID_STYLE_ATTRS = [
    'color',
    'background',
    'backgroundColor',
    'fontFamily',
    'fontWeight',
    'fontStyle',
    'fontSize',
    'borderTopWidth',
    'borderLeftWidth',
    'borderBottomWidth',
    'borderRightWidth',
    'borderColor',
    'borderStyle',
    'borderTopLeftRadius',
    'borderTopRightRadius',
    'borderBottomLeftRadius',
    'borderBottomRightRadius',
    'lineHeight',
    'boxShadow',
    'textShadow',
    'paddingTop',
    'paddingBottom',
    'paddingLeft',
    'paddingRight',
  ];

  @Component({ disableVerticalResize: true })
  class Checkbox extends React.Component {
    static propTypes = {
      text: PropTypes.string,
      style: PropTypes.object,
    };

    static defaultProps = {
      style: Immutable.Map(),
    };

    constructor(props) {
      super(props);

      this.onChange = this.onChange.bind(this);
    }

    onChange(e) {
      const { name, value, onChangeForm } = this.props;

      if (onChangeForm) onChangeForm({ [name]: e.currentTarget.checked ? (value || name) : '' });
    }

    render() {
      const {
        text,
        defaultValue,
        style,
        isPreview,
        onFocus,
        onBlur,
        onMouseEnter,
        onMouseLeave,
      } = this.props;
      const checkboxStyle = {
        padding: '0',
        marginTop: '0',
        marginRight: '8px',
        marginBottom: '0',
        marginLeft: '0',
      };
      const labelStyle = _.pick(this.props.style.toJS(), VALID_STYLE_ATTRS);
      labelStyle.paddingLeft = this.props.style.get('paddingLeft') || '0';
      labelStyle.paddingTop = this.props.style.get('paddingTop') || '0';
      labelStyle.paddingRight = this.props.style.get('paddingRight') || '0';
      labelStyle.paddingBottom = this.props.style.get('paddingBottom') || '0';
      labelStyle.margin = '0';
      labelStyle.display = 'block';
      labelStyle.width = '100%';

      return (
        <label
          ref={(el) => this.textEl = el}
          style={labelStyle}
          onMouseEnter={onMouseEnter}
          onMouseLeave={onMouseLeave}
        >
          <input
            disabled={isPreview}
            type="checkbox"
            defaultChecked={defaultValue}
            style={checkboxStyle}
            onChange={this.onChange}
            onFocus={onFocus}
            onBlur={onBlur}
          />
          {text}
        </label>
      );
    }
  }

  return Checkbox;
});
